import { Box, Stack } from '@mui/material';
import dayjs from 'dayjs';
import { createSGRWarrantyRequest } from 'lib/api/express/sgrWarrantyRequest';
import { CreateFormPruffConnect } from 'lib/api/express/sgrWarrantyRequest/types';
import CreateWarrantyForm from 'lib/common/Forms/Warranty/PruffConnect/Create';
import { SGR_TYPES } from 'lib/consts';
import CustomButton from 'lib/designSystem/Button';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import RiskPremiumCalculator from './RiskPremiumCalculator';

type Props = {
  direction: 'row' | 'column';
  successFn?: () => void;
};

const WarrantyForm = ({ direction = 'column', successFn }: Props) => {
  const dispatch = useDispatch();
  const domain = window.location.hostname;
  const secretId = domain.split('.')[0];
  const initialValues = {
    tenderId: null,
    quotedAmount: 0,
    quotedCurrency: 'CLP',
    type: SGR_TYPES[0].value,
    principalRut: null,
    unitCode: null,
    address: null,
    startDate: dayjs(new Date()),
    endDate: dayjs(new Date()),
    description: null,
  };
  const [form, setForm] = useState<CreateFormPruffConnect>(initialValues);
  const { mutate, isPending } = createSGRWarrantyRequest(dispatch);

  const createQuotation = async () => {
    mutate(
      { data: form, secretId },
      {
        onSuccess: () => {
          setForm(initialValues);
          successFn?.();
        },
      },
    );
  };

  const isFormValid = () => {
    return (
      form.type &&
      form.quotedAmount &&
      form.quotedCurrency &&
      form.startDate &&
      form.endDate &&
      form.principalRut &&
      form.address
    );
  };

  return (
    <Stack direction={direction} gap={2}>
      <CreateWarrantyForm form={form} setForm={setForm} />
      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <RiskPremiumCalculator
          amount={form.quotedAmount}
          startDate={form.startDate}
          endDate={form.endDate}
          quotedCurrency={form.quotedCurrency}
          type={form.type}
        />
        <Stack direction="row" gap={2} justifyContent="flex-end" mt={2}>
          <CustomButton
            color="primary"
            onClick={createQuotation}
            disabled={!isFormValid}
            loading={isPending}
          >
            Crear Cotización
          </CustomButton>
        </Stack>
      </Box>
    </Stack>
  );
};

export default WarrantyForm;
